(function () {
  'use strict';

  if (window.__nailhandyMobileCollectionAutoplay) return;
  window.__nailhandyMobileCollectionAutoplay = true;

  var mobileQuery = window.matchMedia('(max-width: 749px)');
  var reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

  function addQueryListener(query, callback) {
    if (query.addEventListener) query.addEventListener('change', callback);
    else query.addListener(callback);
  }

  function initializeSlider(slider) {
    if (!slider || slider.dataset.nailhandyMobileAutoplayReady === 'true') return;
    slider.dataset.nailhandyMobileAutoplayReady = 'true';

    var timer = null;
    var speed = Number.parseFloat(slider.dataset.nailhandyMobileAutoplaySpeed) || 5.5;
    var delay = Math.max(speed, 4) * 1000;

    function stop() {
      if (timer === null) return;
      window.clearInterval(timer);
      timer = null;
    }

    function canRun() {
      return mobileQuery.matches && !reducedMotionQuery.matches && !document.hidden;
    }

    function moveNext() {
      if (!canRun()) {
        stop();
        return;
      }

      var nextButton = slider.querySelector('.splide__arrow--next');
      if (nextButton && !nextButton.disabled) {
        nextButton.click();
        return;
      }

      var track = slider.querySelector('.splide__track');
      var firstSlide = slider.querySelector('.splide__slide');
      if (!track || !firstSlide) return;

      var gap = Number.parseFloat(slider.dataset.gapMobile) || 0;
      var step = firstSlide.getBoundingClientRect().width + gap;
      var maximum = Math.max(0, track.scrollWidth - track.clientWidth);
      var nextPosition = track.scrollLeft + step;

      if (nextPosition > maximum - step * 0.25) nextPosition = 0;
      track.scrollTo({ left: nextPosition, behavior: 'smooth' });
    }

    function start() {
      stop();
      if (!canRun()) return;
      timer = window.setInterval(moveNext, delay);
    }

    slider.addEventListener('pointerdown', stop, { passive: true });
    slider.addEventListener('pointerup', start, { passive: true });
    slider.addEventListener('pointercancel', start, { passive: true });
    slider.addEventListener('focusin', stop);
    slider.addEventListener('focusout', start);
    slider.addEventListener('mouseenter', stop);
    slider.addEventListener('mouseleave', start);
    document.addEventListener('visibilitychange', start);
    addQueryListener(mobileQuery, start);
    addQueryListener(reducedMotionQuery, start);

    start();
  }

  function initializeAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('[data-nailhandy-mobile-autoplay="true"]').forEach(initializeSlider);
  }

  function ready() {
    initializeAll(document);
    document.addEventListener('shopify:section:load', function (event) {
      initializeAll(event.target);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ready, { once: true });
  } else {
    ready();
  }
})();
